// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import auth from './auth';
import navbar from './navbar';
import layout from './layout';
import profileReducer from './profile';
import profileItemReducer from './profileItem';
import mediaReducer from './media';
import directionReducer from './directions';
import toasterReducer from './toaster';
import ratesReducer from './rates';
import scheduledDepartures from './scheduledDepartures';
import operatorReducer from './operator';
import governanceReducer from './governance';
import tagManagerReducer from './tagManager';
import profileIconReducer from './profileIcon';

import sustainabilityApi from '../apis/sustainability.api';
import {
	sustainabilityFormsReducer,
	sustainabilityReducer,
	sustainabilityQuestionsReducer,
	profileSectionsReducer,
	sustainabilityApprovalReducer,
	certificationReducer,
	profileCertificationsReducer,
	certificateQuestionReducer
} from '../slices';
import certificationApi from '../apis/certification.api';
import goodYouDoApi from '../apis/good-you-do.api';

const rootReducer = combineReducers({
	auth,
	navbar,
	layout,
	profileReducer,
	operatorReducer,
	profileItemReducer,
	mediaReducer,
	profileIconReducer,
	directionReducer,
	toasterReducer,
	ratesReducer,
	scheduledDepartures,
	tagManagerReducer,
	governanceReducer,
	[sustainabilityApi.reducerPath]: sustainabilityApi.reducer,
	sustainabilityForms: sustainabilityFormsReducer,
	sustainability: sustainabilityReducer,
	sustainabilityQuestions: sustainabilityQuestionsReducer,
	profileSections: profileSectionsReducer,
	sustainabilityApproval: sustainabilityApprovalReducer,
	[certificationApi.reducerPath]: certificationApi.reducer,
	[goodYouDoApi.reducerPath]: goodYouDoApi.reducer,
	certification: certificationReducer,
	profileCertifications: profileCertificationsReducer,
	certificateQuestion: certificateQuestionReducer
});

export default rootReducer;
